/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { IncidentsPersonneMoraleDto } from '../models/incidents-personne-morale-dto';
import { LoadResult } from '../models/load-result';
import { PaiementPersonneMoraleDto } from '../models/paiement-personne-morale-dto';
import { PersonneMoraleDto } from '../models/personne-morale-dto';
import { QuotaVisiteurDto } from '../models/quota-visiteur-dto';
import { VisitePersonneMoraleDto } from '../models/visite-personne-morale-dto';


/**
 * Fonctions de gestion des personnes morales
 */
@Injectable({
  providedIn: 'root',
})
export class PersonnesMoralesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation personnesMoralesGetList
   */
  static readonly PersonnesMoralesGetListPath = '/api/personnes-morales/list';

  /**
   * Renvoie la liste des personnes morales.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PersonneMoraleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PersonneMoraleDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des personnes morales.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetList(params?: {
  }): Observable<Array<PersonneMoraleDto>> {

    return this.personnesMoralesGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PersonneMoraleDto>>) => r.body as Array<PersonneMoraleDto>)
    );
  }

  /**
   * Path part for operation personnesMoralesLoadList
   */
  static readonly PersonnesMoralesLoadListPath = '/api/personnes-morales/load-list';

  /**
   * Renvoie la liste des personnes morales (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des personnes morales (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnesMoralesLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnesMoralesGet
   */
  static readonly PersonnesMoralesGetPath = '/api/personnes-morales/{id}';

  /**
   * Renvoie la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGet$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    id: number;
  }): Observable<StrictHttpResponse<PersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonneMoraleDto>;
      })
    );
  }

  /**
   * Renvoie la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGet(params: {

    /**
     * Identifiant de la personne morale
     */
    id: number;
  }): Observable<PersonneMoraleDto> {

    return this.personnesMoralesGet$Response(params).pipe(
      map((r: StrictHttpResponse<PersonneMoraleDto>) => r.body as PersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesPut
   */
  static readonly PersonnesMoralesPutPath = '/api/personnes-morales/{id}';

  /**
   * Met à jour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPut$Response(params: {

    /**
     * Identifiant de la personne morale à mettre à jour
     */
    id: number;

    /**
     * Personne morale
     */
    body: PersonneMoraleDto
  }): Observable<StrictHttpResponse<PersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonneMoraleDto>;
      })
    );
  }

  /**
   * Met à jour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPut(params: {

    /**
     * Identifiant de la personne morale à mettre à jour
     */
    id: number;

    /**
     * Personne morale
     */
    body: PersonneMoraleDto
  }): Observable<PersonneMoraleDto> {

    return this.personnesMoralesPut$Response(params).pipe(
      map((r: StrictHttpResponse<PersonneMoraleDto>) => r.body as PersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesDelete
   */
  static readonly PersonnesMoralesDeletePath = '/api/personnes-morales/{id}';

  /**
   * Supprime la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesDelete$Response(params: {

    /**
     * Identifiant de la personne morale à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesDelete(params: {

    /**
     * Identifiant de la personne morale à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.personnesMoralesDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation personnesMoralesPost
   */
  static readonly PersonnesMoralesPostPath = '/api/personnes-morales';

  /**
   * Crée la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPost$Response(params: {

    /**
     * Personne morale
     */
    body: PersonneMoraleDto
  }): Observable<StrictHttpResponse<PersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonneMoraleDto>;
      })
    );
  }

  /**
   * Crée la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPost(params: {

    /**
     * Personne morale
     */
    body: PersonneMoraleDto
  }): Observable<PersonneMoraleDto> {

    return this.personnesMoralesPost$Response(params).pipe(
      map((r: StrictHttpResponse<PersonneMoraleDto>) => r.body as PersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesDesactivate
   */
  static readonly PersonnesMoralesDesactivatePath = '/api/personnes-morales/{id}/desactivate';

  /**
   * Désactive la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesDesactivate$Response(params: {

    /**
     * Identifiant de la personne morale à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: PersonneMoraleDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesDesactivate(params: {

    /**
     * Identifiant de la personne morale à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: PersonneMoraleDto
  }): Observable<number> {

    return this.personnesMoralesDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation personnesMoralesGetByReference
   */
  static readonly PersonnesMoralesGetByReferencePath = '/api/personnes-morales/reference/{reference}';

  /**
   * Renvoie la personne morale recherchée par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<PersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonneMoraleDto>;
      })
    );
  }

  /**
   * Renvoie la personne morale recherchée par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<PersonneMoraleDto> {

    return this.personnesMoralesGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<PersonneMoraleDto>) => r.body as PersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesVisitesLoadList
   */
  static readonly PersonnesMoralesVisitesLoadListPath = '/api/personnes-morales/visites/load-list/{personneMoraleId}';

  /**
   * Renvoie la liste des visites d'une personne morale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesVisitesLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesVisitesLoadList$Response(params: {

    /**
     * Id de la personne morale spécifiée
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesVisitesLoadListPath, 'post');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des visites d'une personne morale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesVisitesLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesVisitesLoadList(params: {

    /**
     * Id de la personne morale spécifiée
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnesMoralesVisitesLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnesMoralesGet2
   */
  static readonly PersonnesMoralesGet2Path = '/api/personnes-morales/visites/{personneMoraleId}/{visiteId}';

  /**
   * Renvoie la visite spécifiée pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesGet2()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGet2$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant de la visite
     */
    visiteId: number;
  }): Observable<StrictHttpResponse<VisitePersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesGet2Path, 'get');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.path('visiteId', params.visiteId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisitePersonneMoraleDto>;
      })
    );
  }

  /**
   * Renvoie la visite spécifiée pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesGet2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGet2(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant de la visite
     */
    visiteId: number;
  }): Observable<VisitePersonneMoraleDto> {

    return this.personnesMoralesGet2$Response(params).pipe(
      map((r: StrictHttpResponse<VisitePersonneMoraleDto>) => r.body as VisitePersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesIncidentsLoadList
   */
  static readonly PersonnesMoralesIncidentsLoadListPath = '/api/personnes-morales/incidents/load-list/{personneMoraleId}';

  /**
   * Renvoie la liste des incidents d'une personne morale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesIncidentsLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesIncidentsLoadList$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesIncidentsLoadListPath, 'post');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des incidents d'une personne morale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesIncidentsLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesIncidentsLoadList(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnesMoralesIncidentsLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnesMoralesGetIncident
   */
  static readonly PersonnesMoralesGetIncidentPath = '/api/personnes-morales/incidents/{personneMoraleId}/{incidentId}';

  /**
   * Renvoie l'incident spécifié pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesGetIncident()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetIncident$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant de l&#x27;incident
     */
    incidentId: number;
  }): Observable<StrictHttpResponse<IncidentsPersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesGetIncidentPath, 'get');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.path('incidentId', params.incidentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IncidentsPersonneMoraleDto>;
      })
    );
  }

  /**
   * Renvoie l'incident spécifié pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesGetIncident$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetIncident(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant de l&#x27;incident
     */
    incidentId: number;
  }): Observable<IncidentsPersonneMoraleDto> {

    return this.personnesMoralesGetIncident$Response(params).pipe(
      map((r: StrictHttpResponse<IncidentsPersonneMoraleDto>) => r.body as IncidentsPersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesPaiementsLoadList
   */
  static readonly PersonnesMoralesPaiementsLoadListPath = '/api/personnes-morales/paiements/load-list/{personneMoraleId}';

  /**
   * Renvoie la liste des paiements d'une personne morale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesPaiementsLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPaiementsLoadList$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesPaiementsLoadListPath, 'post');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des paiements d'une personne morale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesPaiementsLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPaiementsLoadList(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnesMoralesPaiementsLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnesMoralesGetPaiement
   */
  static readonly PersonnesMoralesGetPaiementPath = '/api/personnes-morales/paiements/{personneMoraleId}/{id}';

  /**
   * Renvoie le paiement spécifié pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesGetPaiement()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetPaiement$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant du paiement
     */
    id: number;
  }): Observable<StrictHttpResponse<PaiementPersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesGetPaiementPath, 'get');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaiementPersonneMoraleDto>;
      })
    );
  }

  /**
   * Renvoie le paiement spécifié pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesGetPaiement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetPaiement(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant du paiement
     */
    id: number;
  }): Observable<PaiementPersonneMoraleDto> {

    return this.personnesMoralesGetPaiement$Response(params).pipe(
      map((r: StrictHttpResponse<PaiementPersonneMoraleDto>) => r.body as PaiementPersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesPutPaiement
   */
  static readonly PersonnesMoralesPutPaiementPath = '/api/personnes-morales/paiements/{personneMoraleId}/{id}';

  /**
   * Met à jour le paiement spécifié pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesPutPaiement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPutPaiement$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant du paiement à mettre à jour
     */
    id: number;

    /**
     * Paiement
     */
    body: PaiementPersonneMoraleDto
  }): Observable<StrictHttpResponse<PaiementPersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesPutPaiementPath, 'put');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaiementPersonneMoraleDto>;
      })
    );
  }

  /**
   * Met à jour le paiement spécifié pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesPutPaiement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPutPaiement(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant du paiement à mettre à jour
     */
    id: number;

    /**
     * Paiement
     */
    body: PaiementPersonneMoraleDto
  }): Observable<PaiementPersonneMoraleDto> {

    return this.personnesMoralesPutPaiement$Response(params).pipe(
      map((r: StrictHttpResponse<PaiementPersonneMoraleDto>) => r.body as PaiementPersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesPostPaiement
   */
  static readonly PersonnesMoralesPostPaiementPath = '/api/personnes-morales/paiements/{personneMoraleId}';

  /**
   * Crée un paiement pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesPostPaiement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPostPaiement$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paiement
     */
    body: PaiementPersonneMoraleDto
  }): Observable<StrictHttpResponse<PaiementPersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesPostPaiementPath, 'post');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaiementPersonneMoraleDto>;
      })
    );
  }

  /**
   * Crée un paiement pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesPostPaiement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesPostPaiement(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paiement
     */
    body: PaiementPersonneMoraleDto
  }): Observable<PaiementPersonneMoraleDto> {

    return this.personnesMoralesPostPaiement$Response(params).pipe(
      map((r: StrictHttpResponse<PaiementPersonneMoraleDto>) => r.body as PaiementPersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesGeneratePmCodes
   */
  static readonly PersonnesMoralesGeneratePmCodesPath = '/api/personnes-morales/codes/{personneMoraleId}';

  /**
   * Génère un nouveau code barres et QR code pour la personne morale et renvoie le code généré.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesGeneratePmCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGeneratePmCodes$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;
  }): Observable<StrictHttpResponse<PersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesGeneratePmCodesPath, 'put');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonneMoraleDto>;
      })
    );
  }

  /**
   * Génère un nouveau code barres et QR code pour la personne morale et renvoie le code généré.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesGeneratePmCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGeneratePmCodes(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;
  }): Observable<PersonneMoraleDto> {

    return this.personnesMoralesGeneratePmCodes$Response(params).pipe(
      map((r: StrictHttpResponse<PersonneMoraleDto>) => r.body as PersonneMoraleDto)
    );
  }

  /**
   * Path part for operation personnesMoralesQuotaLoadList
   */
  static readonly PersonnesMoralesQuotaLoadListPath = '/api/personnes-morales/quota/load-list/{personneMoraleId}';

  /**
   * Renvoie la liste des quotas d'une personne morale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesQuotaLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesQuotaLoadList$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesQuotaLoadListPath, 'post');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des quotas d'une personne morale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesQuotaLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesMoralesQuotaLoadList(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnesMoralesQuotaLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnesMoralesGetQuota
   */
  static readonly PersonnesMoralesGetQuotaPath = '/api/personnes-morales/quota/{personneMoraleId}/{typeDechetId}';

  /**
   * Renvoie le quota spécifié pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesMoralesGetQuota()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetQuota$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant du type de déchets
     */
    typeDechetId: number;
  }): Observable<StrictHttpResponse<QuotaVisiteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesMoralesService.PersonnesMoralesGetQuotaPath, 'get');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.path('typeDechetId', params.typeDechetId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuotaVisiteurDto>;
      })
    );
  }

  /**
   * Renvoie le quota spécifié pour la personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesMoralesGetQuota$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesMoralesGetQuota(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant du type de déchets
     */
    typeDechetId: number;
  }): Observable<QuotaVisiteurDto> {

    return this.personnesMoralesGetQuota$Response(params).pipe(
      map((r: StrictHttpResponse<QuotaVisiteurDto>) => r.body as QuotaVisiteurDto)
    );
  }

}
